/* eslint-disable-next-line import/no-relative-packages */
import { MicroFrontendLoader } from '../../../config';

const spinner = `
  <div class="lds-default">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
`;

export const loaders: Record<MicroFrontendLoader, string | false> = {
  [MicroFrontendLoader.GENERIC]: `
    <div class="absolute h-screen w-screen bg-white dark:bg-[#181824] z-50">
      <div class="lds-wrapper">
        ${spinner}
      </div>
    </div>
  `,
  [MicroFrontendLoader.CONTENT]: `
    <div class="lds-content-wrapper">
      <div class="lds-content">
        ${spinner}
      </div>
    </div>
  `,
  [MicroFrontendLoader.NONE]: false,
};
